/**
 * Sugar syntax for define()ing the namespace, requesting the parent, and passing through the config.
 * @method inherit
 * @param {string} namespace - The id that will be occupied in the global namespace.
 * @param {Blueprint} blueprint - The configuration to extend the parent Class with.
 */
this.inherit = function (namespace, blueprint) {
	return this.define(namespace, [`${blueprint.parent}`], function (Parent) {
		blueprint.namespace = namespace;
		return Parent.inherit(blueprint);
	});
};

/**
 * Local asset tweaks
 * ex. Clearing the global scope
 **/
define(`d3-private`, [`d3`], function (d3) {
	window.d3 = d3; // some dependencies expect this reference to exist
	return d3;
});

define(`Hammer-private`, [`Hammer`, `Hammer-time`], function (Hammer) {
	delete window.Hammer;
	Hammer.defaults.domEvents = true;
	return Hammer;
});

define(`xregexp-private`, [`require`, `lib/xregexp/xregexp.min`], function (require, XRegExp) {
	return new Promise(function (resolve, reject) {
		require([`lib/xregexp/unicode-base.min`], function () {
			require([`lib/xregexp/unicode-categories.min`], function () {
				resolve(window.XRegExp);
				delete window.XRegExp;
			}, reject);
		}, reject);
	});
});

define(
	`jquery-private`,
	[
		// an extra layer of execution before the dependency is returned (i.e. runs once the first time it's requested)
		`jquery`,
		`jquery-mousewheel`,
	],
	function (jQuery) {
		// jquery loaded successfully
		var $ = jQuery.noConflict(true); // remove $ and all other global references
		return $; // return the remaining reference to the library
	}
);

define(
	`lodash-private`,
	[
		// an extra layer of execution before the dependency is returned (i.e. runs once the first time it's requested)
		`lodash`,
	],
	function (lodash) {
		var _ = lodash.noConflict(); // remove all references from the global scope
		return _; // return the remaining reference to it
	}
);

define(`youtube-private`, [`require`, `lodash`], function (require, _) {
	return new Promise(function (resolve, reject) {
		function onYouTubeIframeAPIReady() {
			if (!_.isObject(window.YT)) {
				reject(Error(`Error initializing the YouTube API.`));
			} else {
				resolve(window.YT);
				delete window.YT; // clear global scope
			}

			delete window.onYouTubeIframeAPIReady; // clear global scope
		}
		window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

		require([`youtube`], function (result) {
			// request the api from google
			/* successful */
		}, function (reason) {
			reject(reason);
			delete window.onYouTubeIframeAPIReady; // clear global scope
		});
	});
});

/**
 * Two-stage external asset tweaks
 * ex. Dynamic URLs, with callbacks or app IDs.
 **/
define(
	`google_maps`,
	[
		// requires an api key in the URL, custom implementation
		`require`,
		`lodash`,
		`Config`,
	],
	function (require, _, Config) {
		const { GOOGLE_MAPS_JS_API_KEY } = Config;
		const apiKey = _.isString(GOOGLE_MAPS_JS_API_KEY) ? GOOGLE_MAPS_JS_API_KEY : ``;

		return new Promise(function (resolve, reject) {
			window.onGoogleMapsReady = function onGoogleMapsReady() {
				resolve(window.google.maps);
				delete window.onGoogleMapsReady; // clear the global scope
			};

			const apiUrl = `//maps.googleapis.com/maps/api/js?callback=onGoogleMapsReady&key=${apiKey}`;
			require([apiUrl], function (result) {
				/* successful */
			}, function (reason) {
				reject(reason);
				delete window.onGoogleMapsReady; // clear the global scope
			});
		});
	}
);

define(`recaptcha`, [`require`], function (require, q) {
	return new Promise(function (resolve, reject) {
		function recaptcha_v2_callback() {
			// api is initialized
			resolve(window.grecaptcha); // resolve with the api
			delete window.grecaptcha; // clean global scope
			delete window.recaptcha_v2_callback; // clean global scope
		}
		window.recaptcha_v2_callback = recaptcha_v2_callback;

		// pull the api, using a custom callback name, and disabling auto-rendering
		require([`//www.google.com/recaptcha/api.js?onload=recaptcha_v2_callback&render=explicit`], function (result) {
			/* successful */
		}, function (reason) {
			reject(reason);
			delete window.recaptcha_v2_callback; // clean global scope
		});
	});
});

//# sourceMappingURL=shared.js.map